import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface ShuttersProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Shutters: React.FC<ShuttersProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [shutters, setShutters] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Exterior Features']?.['Shutters'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Exterior Features': { ...s.values?.['Exterior Features'], Shutters: v } } })
    );
    const label = 'Shutters';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={shutters}
                />
            ) : (
                <TextBox
                    value={shutters ?? ''}
                    onChange={(value) => setShutters(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
